export { getMilliseconds } from './src/getMilliseconds';
export { dynamicDebounce } from './src/dynamicDebounce';
export { decayingInterval } from './src/decayingInterval';
